import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top on route change
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Store original scroll behavior
    const originalScrollBehavior = document.documentElement.style.scrollBehavior;
    
    // Temporarily set to auto to ensure immediate jump
    document.documentElement.style.scrollBehavior = 'auto';
    
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
      
      // Restore original scroll behavior after a short delay
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = originalScrollBehavior;
      }, 50);
    });
  }, [pathname]);

  return null;
}